import React from 'react';
import ReactDOM from 'react-dom';

interface ModalProps {
  isOpen: boolean;
  title1: string | React.ReactNode;
  title2: string | React.ReactNode;
  title3: string | React.ReactNode;
  title4: string | React.ReactNode;
  onClose: () => void;
  onConfirm?: (data?: { inp1?: number; inp2?: number; inp3?: number; inp4?: number; notFilled?: boolean }) => void;
}

const DeliveryDialog: React.FC<ModalProps> = ({
                                                isOpen,
                                                title1,
                                                title2,
                                                title3,
                                                title4,
                                                onClose,
                                                onConfirm,
                                              }) => {
  if (!isOpen) return null;

  const [inp1, setInp1] = React.useState<number>();
  const [inp2, setInp2] = React.useState<number>();
  const [inp3, setInp3] = React.useState<number>();
  const [inp4, setInp4] = React.useState<number>();

  const handleConfirm = () => {

    const isEmpty = (val: any) => val === null || val === undefined || val === '';

    if ((isEmpty(inp1) && isEmpty(inp2)) || (isEmpty(inp3) && isEmpty(inp4))) {
      onConfirm?.({notFilled: true});
    } else {
      onConfirm?.({inp1, inp2, inp3, inp4});
    }
    onClose();
  };

  const handleCancel = () => {
    onConfirm?.({notFilled: true});
    onClose();
  };

  return ReactDOM.createPortal(
    <>
      <div className="modal-backdrop show"></div>

      <div
        className="modal d-block"
        tabIndex={-1}
        role="dialog"
        style={{backgroundColor: 'rgba(0,0,0,0.5)'}}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Заповнiть данi</h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={handleCancel}
              ></button>
            </div>
            <div className="modal-body">
              <div className="input-group mb-3">
                <input
                  type="number"
                  className="form-control"
                  value={inp1 ?? ''}
                  onChange={(e) => setInp1(e.target.value ? Number(e.target.value) : undefined)}
                />
                <span className="input-group-text">{title1}</span>
              </div>
              <div className="input-group mb-3">
                <input
                  type="number"
                  className="form-control"
                  value={inp2 ?? ''}
                  onChange={(e) => setInp2(e.target.value ? Number(e.target.value) : undefined)}
                />
                <span className="input-group-text">{title2}</span>
              </div>
              <br/>
              <div className="input-group mb-3">
                <input
                  type="number"
                  className="form-control"
                  value={inp3 ?? ''}
                  onChange={(e) => setInp3(e.target.value ? Number(e.target.value) : undefined)}
                />
                <span className="input-group-text">{title3}</span>
              </div>
              <div className="input-group mb-3">
                <input
                  type="number"
                  className="form-control"
                  value={inp4 ?? ''}
                  onChange={(e) => setInp4(e.target.value ? Number(e.target.value) : undefined)}
                />
                <span className="input-group-text">{title4}</span>
              </div>
            </div>

            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={handleCancel}>
                Cancel
              </button>
              <button type="button" className="btn btn-primary" onClick={handleConfirm}>
                OK
              </button>
            </div>
          </div>
        </div>
      </div>
    </>,
    document.body
  );

};

export default DeliveryDialog;
